import { Box, Button, Spinner, Table, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export interface Props {
  colSpan: number
  onCancelLoading: () => void
}

const TableLoading = ({ colSpan, onCancelLoading }: Props) => (
  <Table.Row>
    <Table.Cell colSpan={colSpan}>
      <Box padding="s48" alignItems="center" justifyContent="center" width="full" gap="s8">
        <Spinner size="s32" />
        <Box>
          <Text weight="bold" size="200">
            {i18n.t(
              'payroll_bundle.results_payments.result_upload.map_to_concepts.table_loading.title'
            )}
          </Text>
        </Box>

        <Box>
          <Text size="200" color="grey800">
            {i18n.t(
              'payroll_bundle.results_payments.result_upload.map_to_concepts.table_loading.description'
            )}
          </Text>
        </Box>
        <Button type="secondary" onClick={onCancelLoading}>
          {i18n.t(
            'payroll_bundle.results_payments.result_upload.map_to_concepts.table_loading.submit'
          )}
        </Button>
      </Box>
    </Table.Cell>
  </Table.Row>
)

export default TableLoading
